"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MacroOffset = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const MacroOffset = ({ colour = "#E6E6E6", size = 16, title = "Macro Offset" }) => (react_1.default.createElement(Base_1.Base, { size: size, fill: colour, smooth: true },
    react_1.default.createElement("title", null, title),
    react_1.default.createElement("path", { d: "M13.9 7l.5-2h-2.3l.9-4h-2l-.9 4h-3L8 1H6l-.9 4h-2l-.4 2h2l-.4 2H2l-.5 2h2.4L3 15h2l.9-4h3L8 15h2l.9-4h2l.5-2h-2.1l.4-2h2.2zM9.3 9h-3l.4-2h3l-.4 2z" })));
exports.MacroOffset = MacroOffset;
//# sourceMappingURL=MacroOffset.js.map